module.exports = __webpack_public_path__ + "static/media/siddharth-ooty-trip-banner.61b73757.jpg";